import { Routes } from '@angular/router';

import { MainPage } from './pages/main-page/main-page';
import { AboutPage } from './pages/about-page/about-page';
import { ProjectPage } from './pages/project-page/project-page';
import {ProjectOverviewPage} from './pages/project-overview-page/project-overview-page';
import {ContactPage} from './pages/contact-page/contact-page';


export const routes: Routes = [
  {
    path: '',
    component: MainPage
  },
  {
    path: 'about',
    component: AboutPage
  },
  {
    path: 'project/:slug',
    component: ProjectPage
  },
  {
    path: 'project/:slug/overview',
    component: ProjectOverviewPage
  },
  {
    path: 'contact',
    component: ContactPage
  },
  {
    path: '**',
    redirectTo: ''
  }
];
